import { render, staticRenderFns } from "./SuratResumeMedisBody.vue?vue&type=template&id=06770c65&"
import script from "./SuratResumeMedisBody.vue?vue&type=script&lang=js&"
export * from "./SuratResumeMedisBody.vue?vue&type=script&lang=js&"
import style0 from "./SuratResumeMedisBody.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports